import { stringifyQuery } from '../utils/query'
import { getApiVersion, http } from '../utils/domain'
// import { buildQueries } from '../utils/transformers'

// import {
//   buildQueries,
// } from '../utils/transformers'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}`
}

// SWR获取app配置信息
export const fetchStandardData = (appId) => {
  return http()
    .post(`${prefix(appId)}/getTablesByTag?tag=STANDARD`, {
      returnSlugs: [
        'title',
        'parentId',
        'parentIds',
        'isDisableNode',
        'level',
        'isParentNode',
        'important',
      ],

      order: {
        desc: false,
        slug: 'childOrder',
      },
      // ...filters,
    })
    .json()
    .catch(() => {
      console.warn('[api] cant load standard')
      return []
    })
}

/**
 * @deprecated
 * 获取全部级联数据
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} slug 父级Id所在字段
 * @param {*} parentSlug 可选，父级id所引用的字段 默认 _id
 * @param {*} byChildOrder 可选，是否根据根据子节点顺序排序 默认true
 * @param {*} obtainDisableNode 可选，是否获取禁用节点 默认true
 * @returns
 */
export const fetchCascadeTreeData = (
  appId,
  tbId,
  slug,
  parentSlug = '_id',
  byChildOrder = true,
  obtainDisableNode = true
) => {
  const params = {
    parentSlug,
    byChildOrder,
    obtainDisableNode,
  }
  return http()
    .post(
      `${prefix(appId)}/tbs/${tbId}/fields/${slug}/cascadeTree${stringifyQuery(
        ...params
      )}`
    )
    .json()
    .catch(() => {
      console.warn('[api] cant load treeData')
      return []
    })
}

/**
 * 修改节点顺序
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectList 指标对象列表 eg. {object1: 1, object2: 4}
 * @returns
 */
export const updateStandardNodeOrder = (appId, tbId, objectList) => {
  return http()
    .put(
      `${prefix(appId)}/tbs/${tbId}/editStandardOrAreaNodeOrder${stringifyQuery(
        {
          tag: 'STANDARD',
        }
      )}`,
      objectList
    )
    .json()
}

/**
 * 添加多级指标的预览
 * @param {*} appId 项目Id
 * @param {*} strList 多级指标列表
 * @returns
 */
export const fetchPreviewTree = (appId, strList) => {
  return http()
    .post(`${prefix(appId)}/tbs/previewTree`, strList)
    .json()
    .catch(() => {
      console.warn('[api] cant load PreviewTree')
      return []
    })
}

/**
 * 添加多级指标
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} parentId 可选，默认不传parentId视为从一级开始添加
 * @param {*} strList 多级指标列表
 * @returns
 */
export const createNestedStandard = (appId, tbId, parentId, strList) => {
  return http()
    .post(
      `${prefix(appId)}/tbs/${tbId}/addMultistageStandardOrArea${stringifyQuery(
        {
          parentId,
          tag: 'STANDARD',
        }
      )}`,
      strList
    )
    .json()
}

/**
 * 删除指标
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 要删除的数据id
 * @returns
 */
export const destroyStandardNode = (appId, tbId, objectId) => {
  return http().delete(
    `${prefix(appId)}/tbs/${tbId}/deleteStandardOrAreaNode${stringifyQuery({
      objectId,
      tag: 'STANDARD',
    })}`,
    null,
    {
      throwHttpErrors: true,
    }
  )
}

/**
 * @deprecated
 * 修改指标
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} item 要修改的数据
 * @returns
 */
export const updateStandardNode = (appId, tbId, item) => {
  return http()
    .put(
      `${prefix(
        appId
      )}/tbs/${tbId}/tbs/{tbId}/editStandardOrAreaNode${stringifyQuery({
        objectId: item.objectId,
        tag: 'STANDARD',
      })}`,
      item
    )
    .json()
}

/**
 * 给表单添加绑定字段
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 指标的objectId
 * @param {*} items 绑定的数据
 * @returns
 */
export const bindStandard = (appId, tbId, bindSlug, objectId) => {
  return http()
    .post(
      `${prefix(appId)}/tbs/${tbId}/addMultiStandardBinding${stringifyQuery({
        bindSlug,
      })}`,
      objectId
    )
    .json()
}

/**
 * 给表单添加解绑字段
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 指标的objectId
 * @param {*} items 解绑的数据
 * @returns
 */
export const unbindStandard = (appId, tbId, unBindSlug, item) => {
  return http()
    .put(
      `${prefix(appId)}/tbs/${tbId}/batchStandardUnbind${stringifyQuery({
        unBindSlug,
      })}`,
      item
    )
    .json()
}

/**
 * 查询单个绑定信息
 * @param {*} appId 项目Id
 * @param {*} tbId 表单Id
 * @param {*} objectId 指标的objectId
 * @returns
 */
export const getBindStandardInfo = (appId, tbId, objectId) => {
  return http()
    .get(
      `${prefix(appId)}/selfRefSlug${stringifyQuery({
        tbId,
        objectId,
      })}`
    )
    .json()
}

/**
 * 查询指标绑定过的表单
 * @param {*} appId
 * @param {*} objectId
 * @returns
 */
export const fetchBindTbs = (appId, objectId) => {
  return http()
    .get(`${prefix(appId)}/selfRefSlug/bindTbs/${objectId}`)
    .json()
}

/**
 * 清除指标缓存
 * @param {*} appId 项目Id
 * @returns
 */
export const cleanStandardCache = (appId) => {
  return http().get(`${prefix(appId)}/getTablesByTag/cleanAll?tag=STANDARD`)
}

/**
 * 节点启用禁用
 * @param {*} appId
 * @param {*} tbId
 * @param {*} objectId
 * @param {*} disable
 * @returns
 */
export const toggleNodeEnabled = (appId, tbId, objectId, disable) => {
  return http().put(
    `${prefix(appId)}/tbs/${tbId}/cascadeTree/disableNode${stringifyQuery({
      tag: 'STANDARD',
      objectId,
      disable,
    })}`
  )
}

/**
 * 导出指标
 * @param {*} appId
 * @param {boolean} obtainDisableNode 是否获取禁用点位
 * @returns
 */
export const getExportStandardUrl = (appId, obtainDisableNode) => {
  return http()
    .get(
      `${prefix(appId)}/tbs/exportStandardTreeDaPing${stringifyQuery({
        obtainDisableNode,
      })}`
    )
    .json()
}

/**
 * 案件指标拆分
 * @param {*} tbId 案件表单id
 * @param {*} targetId 案件拆分表单id
 * @param {*} objectIds 要拆分的案件id
 * @returns
 */
export const caseStandardSplit = (sourceId, targetId, objectIds) => {
  return http()
    .post(`${getApiVersion()}/apps/eventRecord/async`, [
      {
        caseSplitHandler: {
          sourceId,
          targetId,
          caseIds: objectIds,
        },
      },
    ])
    .json()
}
